(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (event.target.getAttribute('form') !== 'CollectionFilters') return;
    var form = document.getElementById('CollectionFilters');
    if (form) {
      form.requestSubmit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  class HorizontalCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.fill = this.querySelector('[data-carousel-progress-fill]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      if (this.fill) {
        this.track.addEventListener('scroll', () => this.updateProgress(), { passive: true });
        this.updateProgress();
      }

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollByAmount(-1));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollByAmount(1));
      }
    }

    scrollByAmount(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9, behavior: 'smooth' });
    }

    updateProgress() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (maxScroll <= 0) {
        this.fill.style.width = '25.7%';
        this.fill.style.transform = 'translateX(0)';
        return;
      }

      const ratio = this.track.scrollWidth > 0 ? this.track.clientWidth / this.track.scrollWidth : 1;
      const width = Math.max(ratio * 100, 10);
      const progress = this.track.scrollLeft / maxScroll;
      const travel = 100 - width;

      this.fill.style.width = width + '%';
      this.fill.style.transform = 'translateX(' + (progress * travel) + '%)';
    }
  }

  if (!customElements.get('horizontal-carousel')) {
    customElements.define('horizontal-carousel', HorizontalCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-gift"]) return;
  try {
    
  class FreeGiftManager extends HTMLElement {
    connectedCallback() {
      // The section renders site-wide; only ever run one instance.
      if (window.__cedarFreeGiftInit) return;
      window.__cedarFreeGiftInit = true;

      this.variantId = parseInt(this.dataset.variantId, 10);
      this.thresholdCents = parseInt(this.dataset.thresholdCents, 10);
      this.toastMessage = this.dataset.toastMessage;
      this.toast = this.querySelector('[data-gift-toast]');

      if (!this.variantId || !this.thresholdCents) {
        console.warn('[free-gift] Missing variant id or threshold; skipping.');
        return;
      }

      this.sync();
    }

    async sync() {
      let cart;
      try {
        const response = await fetch('/cart.js');
        cart = await response.json();
      } catch (error) {
        console.warn('[free-gift] Could not read cart:', error);
        return;
      }

      // Detect the gift by variant id alone. The hidden `_free_gift` property is
      // still written (the cart template uses it for the badge), but matching on
      // the id means a dropped property can never cause a duplicate add / reload loop.
      const giftLine = cart.items.find((item) => item.variant_id === this.variantId);

      const otherItemsTotal = giftLine
        ? cart.total_price - giftLine.final_line_price
        : cart.total_price;
      const qualifies = otherItemsTotal >= this.thresholdCents;

      try {
        if (qualifies && !giftLine) {
          await this.addGift();
          this.showToast();
          this.reloadIfCartPage();
        } else if (!qualifies && giftLine) {
          await this.changeLine(giftLine.key, 0);
          this.reloadIfCartPage();
        } else if (qualifies && giftLine && giftLine.quantity !== 1) {
          // Keep the gift pinned at a quantity of exactly one.
          await this.changeLine(giftLine.key, 1);
          this.reloadIfCartPage();
        }
      } catch (error) {
        console.error('[free-gift] Could not update the cart:', error.message);
      }
    }

    async addGift() {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: this.variantId,
              quantity: 1,
              properties: { _free_gift: 'true' },
            },
          ],
        }),
      });

      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(
          (body.description || body.message || 'add failed') +
            ' — check the gift product is published to the Online Store sales channel and is in stock.'
        );
      }
    }

    async changeLine(lineKey, quantity) {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity }),
      });

      if (!response.ok) throw new Error('cart change failed');
    }

    reloadIfCartPage() {
      // The cart page is server-rendered, so it needs a reload to show the change.
      if (/^\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      }
    }

    showToast() {
      if (!this.toast || !this.toastMessage) return;
      this.toast.textContent = this.toastMessage;
      this.toast.classList.add('is-visible');
      setTimeout(() => this.toast.classList.remove('is-visible'), 4000);
    }
  }

  customElements.define('free-gift-manager', FreeGiftManager);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'))
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'))
      this.activeIndex = 0

      this.updateCta(this.activeIndex)

      if (this.slides.length < 2) return

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index))
      })

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      const autoplay = this.getAttribute('autoplay') === 'true'
      const interval = parseInt(this.getAttribute('interval'), 10) || 5000

      if (autoplay && !prefersReducedMotion) {
        this.timer = setInterval(() => {
          this.goTo((this.activeIndex + 1) % this.slides.length)
        }, interval)
      }
    }

    goTo(index) {
      this.slides[this.activeIndex].classList.remove('hero__slide--active')
      this.dots[this.activeIndex] &&
        this.dots[this.activeIndex].classList.remove('hero__dot--active')
      this.dots[this.activeIndex] &&
        this.dots[this.activeIndex].setAttribute('aria-selected', 'false')

      this.activeIndex = index

      this.slides[this.activeIndex].classList.add('hero__slide--active')
      this.dots[this.activeIndex] && this.dots[this.activeIndex].classList.add('hero__dot--active')
      this.dots[this.activeIndex] &&
        this.dots[this.activeIndex].setAttribute('aria-selected', 'true')

      this.updateCta(this.activeIndex)
    }

    updateCta(index) {
      const hideCta = this.slides[index] && this.slides[index].dataset.hideCtaMobile === 'true'
      this.classList.toggle('hero--hide-cta-mobile', hideCta)
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer)
    }
  }

  customElements.define('hero-carousel', HeroCarousel)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var galleryMain = document.getElementById('ProductMainImage')
    var thumbsList = document.querySelector('.product-gallery__thumbs-list')
    var prevArrow = document.querySelector('.product-gallery__arrow--prev')
    var nextArrow = document.querySelector('.product-gallery__arrow--next')
    var thumbs = Array.from(document.querySelectorAll('.product-gallery__thumb'))

    function activateThumb(thumb) {
      if (!thumb || !galleryMain) return
      var src = thumb.dataset.fullSrc
      if (src) {
        galleryMain.removeAttribute('srcset')
        galleryMain.removeAttribute('sizes')
        galleryMain.src = src
      }
      thumbs.forEach(function (t) {
        t.classList.remove('product-gallery__thumb--active')
      })
      thumb.classList.add('product-gallery__thumb--active')
      if (typeof thumb.scrollIntoView === 'function') {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateThumb(thumb)
      })
    })

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        var activeIndex = thumbs.findIndex(function (t) {
          return t.classList.contains('product-gallery__thumb--active')
        })
        if (activeIndex > 0) {
          activateThumb(thumbs[activeIndex - 1])
        } else {
          activateThumb(thumbs[thumbs.length - 1])
        }
      })
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        var activeIndex = thumbs.findIndex(function (t) {
          return t.classList.contains('product-gallery__thumb--active')
        })
        if (activeIndex >= 0 && activeIndex < thumbs.length - 1) {
          activateThumb(thumbs[activeIndex + 1])
        } else {
          activateThumb(thumbs[0])
        }
      })
    }

    if (galleryMain) {
      var touchStartX = 0
      var touchEndX = 0

      galleryMain.addEventListener(
        'touchstart',
        function (e) {
          if (e.changedTouches && e.changedTouches.length > 0) {
            touchStartX = e.changedTouches[0].screenX
          }
        },
        { passive: true },
      )

      galleryMain.addEventListener(
        'touchend',
        function (e) {
          if (e.changedTouches && e.changedTouches.length > 0) {
            touchEndX = e.changedTouches[0].screenX
            var diff = touchEndX - touchStartX
            if (Math.abs(diff) > 30) {
              var activeIndex = thumbs.findIndex(function (t) {
                return t.classList.contains('product-gallery__thumb--active')
              })
              if (diff < 0 && activeIndex < thumbs.length - 1) {
                activateThumb(thumbs[activeIndex + 1])
              } else if (diff > 0 && activeIndex > 0) {
                activateThumb(thumbs[activeIndex - 1])
              }
            }
          }
        },
        { passive: true },
      )
    }

    var form = document.getElementById('ProductForm')
    if (form) {
      var variants = JSON.parse(form.dataset.variants || '[]')
      var variantIdInput = document.getElementById('ProductSelectedVariantId')
      var priceEl = document.getElementById('ProductPrice')
      var addButton = document.getElementById('ProductAddButton')

      function moneyFormat(cents) {
        return '$' + (cents / 100).toFixed(2)
      }

      function selectedOptions() {
        var options = []
        form.querySelectorAll('.product-buybox__variant-input:checked').forEach(function (input) {
          options[parseInt(input.dataset.optionIndex, 10)] = input.value
        })
        return options
      }

      function findMatchingVariant() {
        var options = selectedOptions()
        return variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return options[index] === undefined || options[index] === value
          })
        })
      }

      form.addEventListener('change', function (event) {
        if (!event.target.classList.contains('product-buybox__variant-input')) return

        var variant = findMatchingVariant()
        if (!variant) return

        variantIdInput.value = variant.id

        if (priceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceEl.innerHTML =
              '<span class="product-buybox__price--sale">' +
              moneyFormat(variant.price) +
              '</span>' +
              '<span class="product-buybox__price--compare">' +
              moneyFormat(variant.compare_at_price) +
              '</span>'
          } else {
            priceEl.textContent = moneyFormat(variant.price)
          }
        }

        if (addButton) {
          addButton.disabled = !variant.available
          addButton.textContent = variant.available
            ? addButton.dataset.addLabel
            : addButton.dataset.soldOutLabel
        }
      })
    }

    var qtyInput = document.getElementById('ProductQuantity')
    document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = parseInt(qtyInput.value, 10) || 1
        qtyInput.value = Math.max(1, value - 1)
      })
    })
    document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = parseInt(qtyInput.value, 10) || 1
        qtyInput.value = value + 1
      })
    })

    // Sticky add-to-cart bar for mobile - brief 2.4.
    var stickyBar = document.querySelector('[data-sticky-atc]')
    var mainAddButton = document.getElementById('ProductAddButton')

    if (stickyBar && mainAddButton) {
      var stickyButton = stickyBar.querySelector('[data-sticky-atc-button]')

      // The bar is hidden in markup so it never flashes before this runs.
      stickyBar.hidden = false

      // Tapping the bar taps the real button, so quantity and variant come
      // from the form rather than being tracked twice.
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          mainAddButton.click()
        })
      }

      // Mirror the real button's label and disabled state, which the variant
      // picker rewrites when the shopper switches size or weight.
      function syncStickyButton() {
        if (!stickyButton) return
        stickyButton.disabled = mainAddButton.disabled
        stickyButton.textContent = mainAddButton.textContent.trim()
      }

      syncStickyButton()

      if (typeof MutationObserver === 'function') {
        new MutationObserver(syncStickyButton).observe(mainAddButton, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
        })
      }

      // Show the bar only once the real button has scrolled away.
      if (typeof IntersectionObserver === 'function') {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              stickyBar.classList.toggle('is-visible', !entry.isIntersecting)
            })
          },
          { rootMargin: '0px 0px -80px 0px' }
        ).observe(mainAddButton)
      } else {
        // Older browsers with no IntersectionObserver still get the bar,
        // just without the show-and-hide behaviour.
        stickyBar.classList.add('is-visible')
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class HorizontalCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.fill = this.querySelector('[data-carousel-progress-fill]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      if (this.fill) {
        this.track.addEventListener('scroll', () => this.updateProgress(), { passive: true });
        this.updateProgress();
      }

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollByAmount(-1));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollByAmount(1));
      }
    }

    scrollByAmount(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9, behavior: 'smooth' });
    }

    updateProgress() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (maxScroll <= 0) {
        this.fill.style.width = '100%';
        this.fill.style.transform = 'translateX(0)';
        return;
      }

      const ratio = this.track.scrollWidth > 0 ? this.track.clientWidth / this.track.scrollWidth : 1;
      const width = Math.max(ratio * 100, 10);
      const progress = this.track.scrollLeft / maxScroll;
      const travel = 100 - width;

      this.fill.style.width = width + '%';
      this.fill.style.transform = 'translateX(' + progress * travel + '%)';
    }
  }

  if (!customElements.get('horizontal-carousel')) {
    customElements.define('horizontal-carousel', HorizontalCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  class WelcomePopup extends HTMLElement {
    connectedCallback() {
      this.backdrop = this.querySelector('[data-popup-backdrop]');
      this.panel = this.querySelector('.welcome-popup__panel');
      this.closeButton = this.querySelector('[data-popup-close]');
      this.storageKey = 'cedar-welcome-popup-dismissed';

      this.closeButton.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      if (this.querySelector('.welcome-popup__content--success')) {
        this.open();
        this.markDismissed();
        return;
      }

      if (this.isDismissed()) return;

      const delay = parseInt(this.dataset.delay, 10) || 3000;
      this.timer = setTimeout(() => this.open(), delay);
    }

    isDismissed() {
      try {
        return window.localStorage.getItem(this.storageKey) === '1';
      } catch (error) {
        return false;
      }
    }

    markDismissed() {
      try {
        window.localStorage.setItem(this.storageKey, '1');
      } catch (error) {
        // Storage unavailable (private browsing, etc.) - popup may reappear on next visit.
      }
    }

    open() {
      this.classList.add('is-open');
      this.panel.setAttribute('aria-hidden', 'false');
    }

    close() {
      clearTimeout(this.timer);
      this.classList.remove('is-open');
      this.panel.setAttribute('aria-hidden', 'true');
      this.markDismissed();
    }

    copyCode() {
      const code = this.querySelector('[data-popup-code]').textContent.trim();
      navigator.clipboard.writeText(code).then(() => {
        const original = this.copyButton.textContent;
        this.copyButton.textContent = this.copyButton.dataset.copiedLabel || 'Copied!';
        setTimeout(() => {
          this.copyButton.textContent = original;
        }, 2000);
      });
    }
  }

  customElements.define('welcome-popup', WelcomePopup);

  } catch(e) { console.error(e); }
})();
})();
